import ReactGA from 'react-ga4';

export const initGA = () => {
    ReactGA.initialize('G-FLE6P56PMH');
};